import { render } from "./MdToggleButton.vue?vue&type=template&id=542b6964&scoped=true"
import script from "./MdToggleButton.vue?vue&type=script&lang=ts"
export * from "./MdToggleButton.vue?vue&type=script&lang=ts"

import "./MdToggleButton.vue?vue&type=style&index=0&id=542b6964&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-542b6964"

export default script